const UserQueries = {};

export default UserQueries;
